import React, { useEffect, useRef, useState } from "react";
import "./Home.scss";
import firstsectionbanner from "../../assets/Group-1.webp";
import initiatingnewprescription from "../../assets/Initiating-New-Prescription.webp";
import HasslefreeRefilling from "../../assets/Hassle-free-Refilling.webp";
import Transfer from "../../assets/Transfer-Your-Existing-Ones.webp";
import Transfer2 from "../../assets/Transfer-Your-Existing-Ones (1).webp";
import BGcircles from "../../assets/Circle Background.png";
import fourthsectioncard from "../../assets/fourthsectioncard.svg";
import pills from "../../assets/pilssicon.svg";
import Doc from "../../assets/DocHomepage.svg";
import pharmacy from "../../assets/pharmacy.svg";
import TestimonialsSwiper from "../../components/TestimonailSwiper/TestimonialsSwiper";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { motion, animate } from "framer-motion";
import { InView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import { domain } from "../../config";

const Home = () => {
  const Desktop = useMediaQuery("(min-width:1268px)");
  function Counter({ from, to }) {
    const nodeRef = useRef();
    useEffect(() => {
      const node = nodeRef.current;

      const controls = animate(from, to, {
        duration: 1,
        onUpdate(value) {
          node.textContent = value.toFixed(0);
        },
      });

      return () => controls.stop();
    }, [from, to]);

    return <span ref={nodeRef} />;
  }

  const [isInView, setIsInView] = useState([]);
  function handleInView(SectionName, InView) {
    if (InView) {
      setIsInView((isInView) => [...isInView, SectionName]);
    }
  }

  return (
    <div className="HomeWrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Britannia Pharmacy</title>
        <link rel="canonical" href={`${domain}/`} />
      </Helmet>
      <div className="SectionOne">
        <div className="wrap">
          <div className="left">
            <motion.svg
              whileInView={{
                scale: [1, 2, 2, 1, 1],
                rotate: [0, 0, 270, 270, 0],
              }}
              transition={{ delay: 1.3, ease: "easeOut", duration: 2 }}
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
              className="floatingstar">
              <path
                d="M29 56.8289C29 56.8289 23.6736 45.0968 18.0859 39.6277C12.332 33.9957 0.267443 29.0001 0.267443 29.0001C0.267443 29.0001 12.4978 24.4557 18.0859 18.6277C23.5407 12.9388 28.0962 0.267533 28.0962 0.267533C28.0962 0.267533 33.9424 12.9069 40.0859 18.6277C45.5194 23.6873 56.8288 28.0963 56.8288 28.0963C56.8288 28.0963 45.5369 34.0206 40.0859 39.6277C34.5565 45.3155 29 56.8289 29 56.8289Z"
                fill="#A2BDF6"
              />
            </motion.svg>
            <p className="note">Welcome to Britannia Pharmacy </p>
            <h1 className="heading">
              <span className="boldwhite">
                <Counter from={0} to={20} /> Years
              </span>{" "}
              <span className="boldBlue"> of Providing</span> <br />{" "}
              Personalized Care<span className="boldwhite"> & </span>
              <span className="lightblue">Expert Advice</span>
            </h1>
            <p className="desc">
              Welcome to Britannia Pharmacy, where your health and well-being
              are at the heart of everything we do.
            </p>
            {Desktop && (
              <div className="buttons">
                <Link className="red" to="/services">
                  Our Services
                </Link>
                <Link className="empty" to="/MinorAliments">
                  Explore Minor Ailments
                </Link>
              </div>
            )}
          </div>
          <div className="right">
            <img src={firstsectionbanner} alt="banner" className="right" />
            {!Desktop && (
              <div className="buttons">
                <Link className="red" to="/services">
                  Our Services
                </Link>
                <Link className="empty" to="/MinorAliments">
                  Explore Minor Ailments
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="SectionTwo">
        <div className="wrap">
          <InView
            as="div"
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
            onChange={(inView) => handleInView("boxes", inView)}
            triggerOnce>
            <div className="upper">
              <p className="note">Comprehensive Prescription Services</p>
              <h2 className="heading">
                Effortless Prescription <br /> Management at Your Fingertips
              </h2>
              <p className="desc">
                Britannia Pharmacy redefines convenience in healthcare with our
                full <br /> spectrum of prescription services. 
              </p>
            </div>
            {isInView.includes("boxes") && (
              <div className="boxes">
                <motion.img
                  initial={{ opacity: 0, scale: 0.7 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ ease: "easeOut", duration: 0.3 }}
                  src={initiatingnewprescription}
                  alt="card"
                />
                <motion.img
                  initial={{ opacity: 0, scale: 0.7 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ ease: "easeOut", delay: 0.25, duration: 0.3 }}
                  src={HasslefreeRefilling}
                  alt="card"
                />
                <motion.img
                  initial={{ opacity: 0, scale: 0.7 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ ease: "easeOut", delay: 0.35, duration: 0.3 }}
                  src={Transfer}
                  alt="card"
                />
                <motion.img
                  initial={{ opacity: 0, scale: 0.7 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ ease: "easeOut", delay: 0.45, duration: 0.3 }}
                  src={Transfer2}
                  alt="card"
                />
              </div>
            )}
          </InView>
          <Link className="ctabutton" to="/Prescription">
            Discover Our Prescription Services{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M5 12H19"
                stroke="#003DA6"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 5L19 12L12 19"
                stroke="#003DA6"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
      <InView
        as="div"
        style={{ width: "-webkit-fill-available" }}
        onChange={(inView) => handleInView("SectionFour", inView)}
        triggerOnce>
        <div className="SectionThree">
          <div className="wrap">
            <div className="upper">
              {Desktop ? (
                <p className="note">
                  Discover the Britannia Phatmacy Difference
                </p>
              ) : (
                <p className="note">Discover the Britannia Difference</p>
              )}

              <p className="heading">
                Experience, Community, and Personalized <br /> Care at the Heart
                of Our Services
              </p>
            </div>
            <div className="boxes">
              <div className="whitebox">
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="title">
                  Decades of Trusted Healthcare Expertise
                </motion.p>
                <motion.p
                  className="desc"
                  initial={{ opacity: 0, x: -50, y: 30 }}
                  whileInView={{ opacity: 1, x: 0, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}>
                  20 years of trusted healthcare, blending experience with a
                  deep understanding of patient needs.
                </motion.p>
                <motion.div
                  initial={Desktop && { opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="imagewrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none">
                    <path
                      d="M19.9999 25C26.4432 25 31.6666 19.7766 31.6666 13.3333C31.6666 6.88997 26.4432 1.66663 19.9999 1.66663C13.5566 1.66663 8.33325 6.88997 8.33325 13.3333C8.33325 19.7766 13.5566 25 19.9999 25Z"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.6834 23.15L11.6667 38.3333L20.0001 33.3333L28.3334 38.3333L26.3167 23.1333"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </motion.div>
              </div>
              <div className="whitebox">
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="title">
                  Your Local Health Partner in Mississauga
                </motion.p>
                <motion.p
                  initial={{ opacity: 0, x: -50, y: 30 }}
                  whileInView={{ opacity: 1, x: 0, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}
                  className="desc">
                  More than a pharmacy – a community pillar in Mississauga,
                  committed to nurturing local health and well-being.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="imagewrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none">
                    <path
                      d="M35.0667 7.68332C34.2154 6.83166 33.2047 6.15607 32.0923 5.69513C30.9799 5.23419 29.7875 4.99695 28.5834 4.99695C27.3792 4.99695 26.1869 5.23419 25.0744 5.69513C23.962 6.15607 22.9513 6.83166 22.1 7.68332L20.3334 9.44999L18.5667 7.68332C16.8472 5.96384 14.5151 4.99784 12.0834 4.99784C9.65165 4.99784 7.31952 5.96384 5.60004 7.68332C3.88055 9.40281 2.91455 11.7349 2.91455 14.1667C2.91455 16.5984 3.88055 18.9305 5.60004 20.65L7.3667 22.4167L20.3334 35.3833L33.3 22.4167L35.0667 20.65C35.9184 19.7987 36.594 18.788 37.0549 17.6756C37.5158 16.5632 37.7531 15.3708 37.7531 14.1667C37.7531 12.9625 37.5158 11.7702 37.0549 10.6577C36.594 9.5453 35.9184 8.53458 35.0667 7.68332Z"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </motion.div>
              </div>
              <div className="whitebox">
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="title">
                  Personalized Health Solutions for You
                </motion.p>
                <motion.p
                  initial={{ opacity: 0, x: -50, y: 30 }}
                  whileInView={{ opacity: 1, x: 0, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}
                  className="desc">
                  Tailored health advice and services for every unique
                  individual, ensuring a personalized health journey.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="imagewrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none">
                    <path
                      d="M37.3333 20H30.6667L25.6667 35L15.6667 5L10.6667 20H4"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </motion.div>
              </div>
            </div>
          </div>
          {isInView.includes("SectionFour") && (
            <img src={BGcircles} alt="BGcircles" className="BGcircles" />
          )}
        </div>
        {isInView.includes("SectionFour") && (
          <div className="SectionFour">
            <div className="wrap">
              <div className="upper">
                <div className="left">
                  <p className="note">
                    Expert Health Services Tailored for You
                  </p>
                  <p className="heading">
                    20 Years of Trusted{" "}
                    {!Desktop && (
                      <motion.svg
                        initial={{ opacity: 0, y: -80 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.8 }}
                        transition={{
                          ease: "easeOut",
                          duration: 0.4,
                          delay: 0.4,
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 38 38"
                        fill="none">
                        <path
                          d="M33.25 15.8334C33.25 26.9167 19 36.4167 19 36.4167C19 36.4167 4.75 26.9167 4.75 15.8334C4.75 12.054 6.25133 8.42949 8.92373 5.7571C11.5961 3.08471 15.2207 1.58337 19 1.58337C22.7793 1.58337 26.4039 3.08471 29.0763 5.7571C31.7487 8.42949 33.25 12.054 33.25 15.8334Z"
                          fill="#7191C9"
                          stroke="#7191C9"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19 20.5834C21.6234 20.5834 23.75 18.4567 23.75 15.8334C23.75 13.21 21.6234 11.0834 19 11.0834C16.3766 11.0834 14.25 13.21 14.25 15.8334C14.25 18.4567 16.3766 20.5834 19 20.5834Z"
                          fill="#003DA6"
                        />
                      </motion.svg>
                    )}{" "}
                    Care{" "}
                    {Desktop && (
                      <motion.svg
                        initial={{ opacity: 0, y: -80 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.8 }}
                        transition={{
                          ease: "easeOut",
                          duration: 0.4,
                          delay: 0.4,
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none">
                        <path
                          d="M33.25 15.8334C33.25 26.9167 19 36.4167 19 36.4167C19 36.4167 4.75 26.9167 4.75 15.8334C4.75 12.054 6.25133 8.42949 8.92373 5.7571C11.5961 3.08471 15.2207 1.58337 19 1.58337C22.7793 1.58337 26.4039 3.08471 29.0763 5.7571C31.7487 8.42949 33.25 12.054 33.25 15.8334Z"
                          fill="#7191C9"
                          stroke="#7191C9"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19 20.5834C21.6234 20.5834 23.75 18.4567 23.75 15.8334C23.75 13.21 21.6234 11.0834 19 11.0834C16.3766 11.0834 14.25 13.21 14.25 15.8334C14.25 18.4567 16.3766 20.5834 19 20.5834Z"
                          fill="#003DA6"
                        />
                      </motion.svg>
                    )}
                    <br /> and Services in Mississauga
                  </p>
                  {Desktop && (
                    <p className="desc">
                      At Britannia Pharmacy, we're more than just a place to
                      fill prescriptions. With over two decades of dedicated
                      service, our pharmacy has become a cornerstone of health
                      in our community. We offer specialized services to ensure
                      your health needs are met with expertise and care.
                    </p>
                  )}
                </div>
                <div className="right">
                  <img src={fourthsectioncard} alt="card" className="right" />
                  {!Desktop && (
                    <p className="desc">
                      At Britannia Pharmacy, we're more than just a place to
                      fill prescriptions. With over two decades of dedicated
                      service, our pharmacy has become a cornerstone of health
                      in our community. We offer specialized services to ensure
                      your health needs are met with expertise and care.
                    </p>
                  )}
                </div>
                <motion.svg
                  whileInView={{
                    scale: [1, 2, 2, 1, 1],
                    rotate: [0, 0, 270, 270, 0],
                  }}
                  transition={{ ease: "easeOut", duration: 2 }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="39"
                  viewBox="0 0 38 39"
                  fill="none"
                  className="bg">
                  <path
                    opacity="0.4"
                    d="M19.0192 38.2688C19.0192 38.2688 15.4934 30.5029 11.7947 26.8827C7.98598 23.1547 1.68263e-05 19.8479 1.68263e-05 19.8479C1.68263e-05 19.8479 8.09574 16.8398 11.7947 12.982C15.4054 9.21635 18.4209 0.828755 18.4209 0.828755C18.4209 0.828755 22.2907 9.19521 26.3574 12.982C29.954 16.3312 37.4401 19.2497 37.4401 19.2497C37.4401 19.2497 29.9656 23.1712 26.3574 26.8827C22.6972 30.6477 19.0192 38.2688 19.0192 38.2688Z"
                    fill="#A2BDF6"
                  />
                </motion.svg>
              </div>
              <div className="boxes">
                <div className="box">
                  <motion.svg
                    initial={Desktop && { opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M35.752 6.9625C27.802 -0.987501 14.9125 -0.987501 6.9625 6.9625C-0.987501 14.9125 -0.987501 27.802 6.9625 35.752L24.248 53.0375C32.198 60.9875 45.0875 60.9875 53.0375 53.0375C60.9875 45.0875 60.9875 32.198 53.0375 24.248L35.752 6.9625ZM9.82382 9.82382C16.1936 3.45407 26.521 3.45408 32.8907 9.82382L40.7068 17.6399C40.6971 17.6709 40.6871 17.7026 40.6768 17.7349C40.4344 18.4937 40.0221 19.6154 39.3557 20.9982C38.0239 23.7615 35.6737 27.5748 31.6236 31.6249C27.5735 35.675 23.7605 38.0248 20.9976 39.3563C19.615 40.0225 18.4935 40.4347 17.7349 40.6769C17.7026 40.6872 17.671 40.6972 17.64 40.7069L9.82382 32.8907C3.45408 26.521 3.45407 16.1936 9.82382 9.82382ZM20.8 43.8669L27.1093 50.1762C33.479 56.5459 43.8064 56.5459 50.1762 50.1762C56.5459 43.8064 56.5459 33.479 50.1762 27.1093L43.8667 20.7998C43.6289 21.39 43.3431 22.0451 43.0009 22.7551C41.4905 25.8889 38.8858 30.0854 34.4849 34.4862C30.0841 38.887 25.8879 41.4915 22.7543 43.0016C22.0447 43.3435 21.3899 43.6292 20.8 43.8669Z"
                      fill="white"
                      stroke="white"
                    />
                  </motion.svg>
                  <div className="textbox">
                    <motion.p
                      initial={Desktop && { opacity: 0, x: -50, y: -30 }}
                      whileInView={{ opacity: 1, x: 0, y: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{
                        ease: "easeOut",
                        duration: 0.4,
                        delay: 0.2,
                      }}
                      className="title">
                      Meds Check
                    </motion.p>
                    <motion.p
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{ ease: "easeOut", duration: 0.4 }}
                      className="desc">
                      Our comprehensive medication review ensures you get the
                      most out of your prescriptions, with personalized advice
                      and adjustments as needed.
                    </motion.p>
                  </div>
                </div>
                <div className="box">
                  <motion.svg
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="58"
                    height="58"
                    viewBox="0 0 58 58"
                    fill="none">
                    <g clip-path="url(#clip0_359_2462)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M53.1846 28.9759L43.3869 28.9832C43.5466 29.4375 43.6351 29.9266 43.6366 30.4347V31.3636C43.6366 32.7963 42.9471 34.0678 41.8803 34.8618C42.3012 35.5295 42.5436 36.322 42.545 37.1697V38.0986C42.5456 38.6706 42.4335 39.2371 42.2151 39.7657C41.9967 40.2943 41.6763 40.7748 41.2722 41.1795C40.8681 41.5843 40.3882 41.9055 39.8599 42.1248C39.3317 42.3441 38.7654 42.4571 38.1934 42.4575H37.4082C37.5678 42.9118 37.6564 43.401 37.6564 43.909L37.6578 44.838C37.6584 45.41 37.5463 45.9764 37.3279 46.5051C37.1095 47.0337 36.7891 47.5141 36.385 47.9189C35.9809 48.3237 35.501 48.6449 34.9727 48.8641C34.4445 49.0834 33.8782 49.1965 33.3062 49.1969L17.2482 49.2099C7.70013 49.2172 -0.0465681 41.4835 -0.0538256 31.9355C-0.0571058 28.3842 1.03344 24.918 3.06953 22.0082C5.10561 19.0985 7.98843 16.8864 11.326 15.6728L28.7165 9.3515C29.5593 9.0451 30.4723 8.98726 31.3469 9.18489C32.2216 9.38252 33.0211 9.82729 33.6502 10.4663C36.0365 12.8903 35.1191 16.969 31.9258 18.1418L28.6091 19.3568L53.1773 19.3379C54.4554 19.3369 55.6815 19.8437 56.586 20.7468C57.4904 21.6498 57.999 22.8752 58 24.1533C58.0009 25.4313 57.4942 26.6575 56.5911 27.5619C55.688 28.4663 54.4627 28.9749 53.1846 28.9759ZM53.1788 22.2409C53.6869 22.2405 54.1744 22.442 54.534 22.8011C54.8936 23.1601 55.0959 23.6473 55.0962 24.1554C55.0966 24.6636 54.8951 25.1511 54.5361 25.5107C54.177 25.8703 53.6898 26.0725 53.1817 26.0729H52.1918C52.1939 26.0371 52.1949 26.0013 52.1947 25.9655V25.9568C52.1947 24.7549 50.8941 23.7795 49.2917 23.7824C47.6877 23.7824 46.3886 24.7593 46.3886 25.9611C46.3886 26.0003 46.3901 26.0395 46.393 26.0772L31.1739 26.0903L31.1768 28.9933L39.2806 28.9861C39.6656 28.9861 40.0348 29.139 40.307 29.4112C40.5792 29.6834 40.7321 30.0526 40.7321 30.4376L40.7336 31.3665C40.7336 31.7515 40.5806 32.1207 40.3084 32.3929C40.0362 32.6651 39.667 32.818 39.2821 32.818L31.1797 32.8253L31.1826 35.7283L38.1891 35.7225C38.574 35.7225 38.9432 35.8754 39.2154 36.1476C39.4877 36.4199 39.6406 36.7891 39.6406 37.174L39.642 38.1015C39.642 38.4865 39.4891 38.8557 39.2169 39.1279C38.9447 39.4001 38.5755 39.553 38.1905 39.553L27.8761 39.5632L27.879 42.4662L33.3018 42.4619C33.6866 42.4619 34.0555 42.6146 34.3277 42.8865C34.5999 43.1584 34.753 43.5272 34.7533 43.9119L34.7548 44.8409C34.7548 45.2259 34.6019 45.5951 34.3297 45.8673C34.0574 46.1395 33.6883 46.2924 33.3033 46.2924L17.2453 46.3069C9.30115 46.3127 2.855 39.8767 2.84919 31.9326C2.84669 28.9777 3.75429 26.0936 5.4486 23.6727C7.14291 21.2517 9.54171 19.4113 12.3188 18.4017L29.7079 12.0803C30.146 11.9361 30.623 11.9679 31.0381 12.169C31.4531 12.3701 31.7738 12.7248 31.9321 13.1579C32.0904 13.5911 32.0741 14.0689 31.8866 14.4903C31.699 14.9117 31.355 15.2436 30.9272 15.4159L27.609 16.6323C24.5623 17.7499 25.3664 22.2641 28.6106 22.2598L53.1788 22.2409Z"
                        fill="white"
                      />
                      <path
                        d="M49.3062 42.6504C51.7447 42.6504 53.6592 40.8215 53.6578 38.4991C53.6549 36.3436 49.296 31.0383 49.296 31.0383C49.296 31.0383 44.9458 36.1854 44.9487 38.5078C44.9487 40.8302 46.8676 42.6533 49.3062 42.6504Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_359_2462">
                        <rect width="58" height="58" fill="white" />
                      </clipPath>
                    </defs>
                  </motion.svg>
                  <div className="textbox">
                    <motion.p
                      initial={{ opacity: 0, x: -50, y: -30 }}
                      whileInView={{ opacity: 1, x: 0, y: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{
                        ease: "easeOut",
                        duration: 0.4,
                        delay: 0.2,
                      }}
                      className="title">
                      Diabetes Counselling
                    </motion.p>
                    <motion.p
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{ ease: "easeOut", duration: 0.4 }}
                      className="desc">
                      Navigate the complexities of diabetes management with our
                      expert counselling services. We guide medication,
                      lifestyle adjustments, and ongoing support.
                    </motion.p>
                  </div>
                </div>
                <div className="box">
                  <motion.svg
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="58"
                    height="58"
                    viewBox="0 0 58 58"
                    fill="none">
                    <path
                      d="M47.1251 32.7992L29.0001 50.7502L22.0014 43.8192M7.21864 24.2345C7.19844 21.6858 7.9847 19.196 9.46498 17.1211C10.9453 15.0462 13.0437 13.4925 15.4603 12.6823C17.8769 11.872 20.4878 11.8466 22.9196 12.6098C25.3515 13.373 27.4798 14.8856 29.0001 16.9313C29.9994 15.6022 31.2624 14.4937 32.7099 13.6751C34.1574 12.8566 35.7583 12.3456 37.4123 12.1742C39.0664 12.0028 40.738 12.1746 42.3226 12.679C43.9072 13.1833 45.3706 14.0093 46.6213 15.1052C47.872 16.2012 48.883 17.5434 49.5911 19.0481C50.2991 20.5527 50.689 22.1873 50.7363 23.8496C50.7836 25.5118 50.4873 27.1659 49.8659 28.7084C49.2445 30.2508 48.3114 31.6484 47.1251 32.8137M7.25012 31.4168H12.0835L16.9168 38.6668L21.7501 24.1668L24.1668 31.4168H31.4168"
                      stroke="white"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </motion.svg>
                  <div className="textbox">
                    <motion.p
                      initial={{ opacity: 0, x: -50, y: -30 }}
                      whileInView={{ opacity: 1, x: 0, y: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{
                        ease: "easeOut",
                        duration: 0.4,
                        delay: 0.2,
                      }}
                      className="title">
                      Complimentary Health Monitoring Services
                    </motion.p>
                    <motion.p
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{ ease: "easeOut", duration: 0.4 }}
                      className="desc">
                      Stay on top of your health with our complimentary blood
                      pressure and diabetes monitoring services. Quick,
                      accurate, and convenient, we provide essential checks to
                      help you easily manage your well-being.
                    </motion.p>
                  </div>
                </div>
                <div className="box">
                  <motion.img
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    src={pills}
                    alt="icon"
                  />
                  <div className="textbox">
                    <motion.p
                      initial={{ opacity: 0, x: -50, y: -30 }}
                      whileInView={{ opacity: 1, x: 0, y: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{
                        ease: "easeOut",
                        duration: 0.4,
                        delay: 0.2,
                      }}
                      className="title">
                      Weekly or Monthly <br /> Compliance Packs 
                    </motion.p>
                    <motion.p
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true, amount: 0.8 }}
                      transition={{ ease: "easeOut", duration: 0.4 }}
                      className="desc">
                      Streamline your medication routine with Britannia
                      Pharmacy's Compliance Packs. Choose weekly or monthly
                      packaging for easy, organized medication management.
                    </motion.p>
                  </div>
                </div>
              </div>
              <div className="cta">
                <div className="left">
                  <motion.svg
                    whileInView={{
                      scale: [1, 2, 2, 1, 1],
                      rotate: [0, 0, 270, 270, 0],
                    }}
                    transition={{ ease: "easeOut", duration: 2 }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="57"
                    height="57"
                    viewBox="0 0 57 57"
                    fill="none">
                    <path
                      d="M28.7327 56.5613C28.7327 56.5613 23.4062 44.8293 17.8186 39.3601C12.0646 33.7281 0.000108719 28.7325 0.000108719 28.7325C0.000108719 28.7325 12.2305 24.1881 17.8186 18.3601C23.2734 12.6712 27.8289 -4.52995e-05 27.8289 -4.52995e-05C27.8289 -4.52995e-05 33.6751 12.6393 39.8186 18.3601C45.2521 23.4197 56.5614 27.8287 56.5614 27.8287C56.5614 27.8287 45.2696 33.753 39.8186 39.3601C34.2892 45.0479 28.7327 56.5613 28.7327 56.5613Z"
                      fill="#A2BDF6"
                    />
                  </motion.svg>
                  <p>
                    Each service is delivered with the same commitment to
                    excellence that has defined Britannia <br /> Pharmacy for
                    the past 20 years. We're here to support your health journey
                    every step of the way
                  </p>
                </div>
                <Link className="right" to="/services">
                  Learn More{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none">
                    <path
                      d="M5 12.2808H19"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 5.28076L19 12.2808L12 19.2808"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        )}
        {isInView.includes("SectionFour") && (
          <div className="SectionFive">
            <div className="wrap">
              <div className="upper">
                <p className="note">Expert Care for Common Ailments</p>
                <h2 className="heading">
                  Certified and Compassionate Treating <br />{" "}
                  <span style={{ color: "#003DA6" }}>
                    16 Minor Ailments with Expertise
                  </span>
                </h2>
              </div>
              <div className="boxes">
                <div className="box">
                  <motion.div
                    initial={Desktop && { opacity: 0, x: -50, y: -30 }}
                    whileInView={{ opacity: 1, x: 0, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}
                    className="imagewrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="35"
                      viewBox="0 0 36 35"
                      fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.31258 21.5198C7.31258 20.8639 7.84424 20.3323 8.50008 20.3323H21.1667C21.8226 20.3323 22.3542 20.8639 22.3542 21.5198C22.3542 22.1756 21.8226 22.7073 21.1667 22.7073H8.50008C7.84424 22.7073 7.31258 22.1756 7.31258 21.5198Z"
                        fill="#003DA6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.31258 27.0614C7.31258 26.4056 7.84424 25.8739 8.50008 25.8739H17.2084C17.8643 25.8739 18.3959 26.4056 18.3959 27.0614C18.3959 27.7173 17.8643 28.2489 17.2084 28.2489H8.50008C7.84424 28.2489 7.31258 27.7173 7.31258 27.0614Z"
                        fill="#003DA6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.3959 3.04887C17.6669 2.925 16.6732 2.91561 14.8806 2.91561C11.8458 2.91561 9.68876 2.91811 8.05335 3.13699C6.45119 3.35141 5.53058 3.75363 4.86143 4.42279C4.19135 5.09287 3.7897 6.01064 3.57553 7.60362C3.35677 9.23075 3.35425 11.3756 3.35425 14.3948V20.7281C3.35425 23.7472 3.35677 25.8921 3.57553 27.5193C3.7897 29.1122 4.19135 30.03 4.86143 30.7001C5.53151 31.3702 6.44928 31.7718 8.04226 31.986C9.66939 32.2048 11.8143 32.2073 14.8334 32.2073H21.1667C24.1859 32.2073 26.3308 32.2048 27.9579 31.986C29.5509 31.7718 30.4687 31.3702 31.1387 30.7001C31.8088 30.03 32.2105 29.1122 32.4246 27.5193C32.6434 25.8921 32.6459 23.7472 32.6459 20.7281V20.036C32.6459 17.604 32.6289 16.4511 32.3707 15.5823H27.4151C25.6214 15.5823 24.1557 15.5823 22.9985 15.4268C21.7889 15.2641 20.7402 14.9122 19.9031 14.0751C19.066 13.238 18.7141 12.1893 18.5514 10.9797C18.3958 9.82251 18.3959 8.35677 18.3959 6.56311V3.04887ZM20.7709 4.2764V6.47811C20.7709 8.37765 20.7734 9.68285 20.9052 10.6632C21.0325 11.6095 21.2602 12.0734 21.5825 12.3957C21.9047 12.718 22.3687 12.9457 23.3149 13.0729C24.2953 13.2048 25.6005 13.2073 27.5001 13.2073H30.6976C30.2282 12.752 29.6268 12.2065 28.8459 11.5036L22.5778 5.86238C21.8093 5.17071 21.2373 4.66016 20.7709 4.2764ZM15.1112 0.540567C17.3035 0.539981 18.7199 0.539602 20.0235 1.03984C21.327 1.54007 22.3751 2.48382 23.9966 3.94398C24.0526 3.99439 24.1093 4.04541 24.1666 4.09705L30.4347 9.73831C30.5014 9.79836 30.5673 9.85765 30.6325 9.91623C32.5066 11.6019 33.7185 12.6919 34.3704 14.1556C35.0222 15.6193 35.0217 17.2493 35.021 19.77C35.0209 19.8576 35.0209 19.9463 35.0209 20.036V20.8174C35.0209 23.7272 35.021 26.032 34.7785 27.8357C34.5289 29.6921 34.003 31.1946 32.8181 32.3795C31.6332 33.5644 30.1307 34.0902 28.2744 34.3398C26.4706 34.5823 24.1659 34.5823 21.2561 34.5823H14.7441C11.8343 34.5823 9.52955 34.5823 7.7258 34.3398C5.86946 34.0902 4.36696 33.5644 3.18205 32.3795C1.99714 31.1946 1.47129 29.6921 1.22171 27.8357C0.979203 26.032 0.979223 23.7272 0.979249 20.8174V14.3054C0.979223 11.3957 0.979203 9.09091 1.22171 7.28715C1.47129 5.43082 1.99714 3.92832 3.18205 2.74341C4.36788 1.55757 5.87542 1.0323 7.73829 0.782976C9.54956 0.540563 11.8658 0.540582 14.7915 0.540607L14.8806 0.540608C14.9584 0.540608 15.0353 0.540587 15.1112 0.540567Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M18.3959 3.04887H18.6459V2.83777L18.4378 2.8024L18.3959 3.04887ZM8.05335 3.13699L8.02018 2.8892L8.05335 3.13699ZM4.86143 4.42279L4.68465 4.24601L4.86143 4.42279ZM3.57553 7.60362L3.32776 7.57031L3.57553 7.60362ZM3.57553 27.5193L3.32776 27.5526L3.57553 27.5193ZM4.86143 30.7001L5.03821 30.5233H5.0382L4.86143 30.7001ZM8.04226 31.986L8.07557 31.7382L8.04226 31.986ZM27.9579 31.986L27.9246 31.7382L27.9579 31.986ZM31.1387 30.7001L31.3155 30.8769L31.1387 30.7001ZM32.4246 27.5193L32.1769 27.486L32.4246 27.5193ZM32.3707 15.5823L32.6104 15.5111L32.5572 15.3323H32.3707V15.5823ZM27.4151 15.5823V15.3323H27.4151L27.4151 15.5823ZM22.9985 15.4268L22.9652 15.6745L22.9985 15.4268ZM19.9031 14.0751L19.7263 14.2519L19.9031 14.0751ZM18.5514 10.9797L18.3037 11.013L18.5514 10.9797ZM18.3959 6.56311L18.6459 6.56312V6.56311H18.3959ZM20.7709 4.2764L20.9298 4.08335L20.5209 3.74697V4.2764H20.7709ZM20.9052 10.6632L20.6575 10.6966L20.9052 10.6632ZM23.3149 13.0729L23.3483 12.8252L23.3149 13.0729ZM30.6976 13.2073V13.4573H31.3143L30.8716 13.0278L30.6976 13.2073ZM28.8459 11.5036L28.6787 11.6895H28.6787L28.8459 11.5036ZM22.5778 5.86238L22.7451 5.67655H22.7451L22.5778 5.86238ZM20.0235 1.03984L20.113 0.806432V0.806432L20.0235 1.03984ZM15.1112 0.540567L15.1113 0.790567L15.1112 0.540567ZM23.9966 3.94398L23.8293 4.12976L23.8293 4.12976L23.9966 3.94398ZM24.1666 4.09705L23.9994 4.28288V4.28288L24.1666 4.09705ZM30.4347 9.73831L30.2675 9.92413L30.2675 9.92413L30.4347 9.73831ZM30.6325 9.91623L30.7996 9.73035H30.7996L30.6325 9.91623ZM34.3704 14.1556L34.142 14.2573V14.2573L34.3704 14.1556ZM35.021 19.77L35.271 19.7701V19.7701L35.021 19.77ZM35.0209 20.8174H34.7709V20.8174L35.0209 20.8174ZM34.7785 27.8357L34.5307 27.8024L34.7785 27.8357ZM32.8181 32.3795L32.6413 32.2027L32.8181 32.3795ZM28.2744 34.3398L28.2411 34.092L28.2744 34.3398ZM21.2561 34.5823L21.2561 34.3323H21.2561V34.5823ZM14.7441 34.5823V34.3323H14.7441L14.7441 34.5823ZM7.7258 34.3398L7.75911 34.092L7.7258 34.3398ZM3.18205 32.3795L3.35883 32.2027H3.35883L3.18205 32.3795ZM1.22171 27.8357L1.46948 27.8024L1.22171 27.8357ZM0.979249 20.8174L1.22925 20.8174V20.8174H0.979249ZM0.979249 14.3054H1.22925V14.3054L0.979249 14.3054ZM1.22171 7.28715L1.46948 7.32047L1.22171 7.28715ZM3.18205 2.74341L3.35883 2.92019L3.18205 2.74341ZM7.73829 0.782976L7.70513 0.535185L7.73829 0.782976ZM14.7915 0.540607L14.7915 0.790607L14.7915 0.540607ZM14.8806 0.540608L14.8806 0.790608H14.8806V0.540608ZM8.50008 20.0823C7.70617 20.0823 7.06258 20.7259 7.06258 21.5198H7.56258C7.56258 21.002 7.98231 20.5823 8.50008 20.5823V20.0823ZM21.1667 20.0823H8.50008V20.5823H21.1667V20.0823ZM22.6042 21.5198C22.6042 20.7259 21.9607 20.0823 21.1667 20.0823V20.5823C21.6845 20.5823 22.1042 21.002 22.1042 21.5198H22.6042ZM21.1667 22.9573C21.9607 22.9573 22.6042 22.3137 22.6042 21.5198H22.1042C22.1042 22.0375 21.6845 22.4573 21.1667 22.4573V22.9573ZM8.50008 22.9573H21.1667V22.4573H8.50008V22.9573ZM7.06258 21.5198C7.06258 22.3137 7.70617 22.9573 8.50008 22.9573V22.4573C7.98231 22.4573 7.56258 22.0375 7.56258 21.5198H7.06258ZM8.50008 25.6239C7.70617 25.6239 7.06258 26.2675 7.06258 27.0614H7.56258C7.56258 26.5437 7.98231 26.1239 8.50008 26.1239V25.6239ZM17.2084 25.6239H8.50008V26.1239H17.2084V25.6239ZM18.6459 27.0614C18.6459 26.2675 18.0023 25.6239 17.2084 25.6239V26.1239C17.7262 26.1239 18.1459 26.5437 18.1459 27.0614H18.6459ZM17.2084 28.4989C18.0023 28.4989 18.6459 27.8553 18.6459 27.0614H18.1459C18.1459 27.5792 17.7262 27.9989 17.2084 27.9989V28.4989ZM8.50008 28.4989H17.2084V27.9989H8.50008V28.4989ZM7.06258 27.0614C7.06258 27.8553 7.70617 28.4989 8.50008 28.4989V27.9989C7.98231 27.9989 7.56258 27.5792 7.56258 27.0614H7.06258ZM14.8806 3.16561C16.6822 3.16561 17.6508 3.17584 18.354 3.29534L18.4378 2.8024C17.6831 2.67416 16.6642 2.66561 14.8806 2.66561V3.16561ZM8.08651 3.38478C9.70146 3.16864 11.8387 3.16561 14.8806 3.16561V2.66561C11.853 2.66561 9.67607 2.66758 8.02018 2.8892L8.08651 3.38478ZM5.03821 4.59956C5.65303 3.98474 6.51191 3.59552 8.08651 3.38478L8.02018 2.8892C6.39047 3.10731 5.40814 3.52252 4.68465 4.24601L5.03821 4.59956ZM3.8233 7.63693C4.03373 6.07179 4.42226 5.21551 5.03821 4.59956L4.68465 4.24601C3.96043 4.97023 3.54568 5.94949 3.32776 7.57031L3.8233 7.63693ZM3.60425 14.3948C3.60425 11.3685 3.60731 9.24351 3.8233 7.63693L3.32776 7.57031C3.10624 9.21799 3.10425 11.3828 3.10425 14.3948H3.60425ZM3.60425 20.7281V14.3948H3.10425V20.7281H3.60425ZM3.8233 27.486C3.60731 25.8794 3.60425 23.7544 3.60425 20.7281H3.10425C3.10425 23.7401 3.10624 25.9049 3.32776 27.5526L3.8233 27.486ZM5.0382 30.5233C4.42226 29.9074 4.03373 29.0511 3.8233 27.486L3.32776 27.5526C3.54568 29.1734 3.96043 30.1527 4.68465 30.8769L5.0382 30.5233ZM8.07557 31.7382C6.51043 31.5278 5.65415 31.1393 5.03821 30.5233L4.68465 30.8769C5.40887 31.6011 6.38813 32.0158 8.00895 32.2338L8.07557 31.7382ZM14.8334 31.9573C11.8071 31.9573 9.68215 31.9542 8.07557 31.7382L8.00895 32.2338C9.65664 32.4553 11.8215 32.4573 14.8334 32.4573V31.9573ZM21.1667 31.9573H14.8334V32.4573H21.1667V31.9573ZM27.9246 31.7382C26.318 31.9542 24.1931 31.9573 21.1667 31.9573V32.4573C24.1787 32.4573 26.3435 32.4553 27.9912 32.2338L27.9246 31.7382ZM30.962 30.5233C30.346 31.1393 29.4897 31.5278 27.9246 31.7382L27.9912 32.2338C29.612 32.0158 30.5913 31.6011 31.3155 30.8769L30.962 30.5233ZM32.1769 27.486C31.9664 29.0511 31.5779 29.9074 30.962 30.5233L31.3155 30.8769C32.0397 30.1527 32.4545 29.1734 32.6724 27.5526L32.1769 27.486ZM32.3959 20.7281C32.3959 23.7544 32.3929 25.8794 32.1769 27.486L32.6724 27.5526C32.8939 25.9049 32.8959 23.7401 32.8959 20.7281H32.3959ZM32.3959 20.036V20.7281H32.8959V20.036H32.3959ZM32.1311 15.6535C32.3763 16.4789 32.3959 17.5872 32.3959 20.036H32.8959C32.8959 17.6208 32.8814 16.4233 32.6104 15.5111L32.1311 15.6535ZM22.9652 15.6745C24.1427 15.8329 25.6278 15.8323 27.4151 15.8323L27.4151 15.3323C25.615 15.3323 24.1686 15.3318 23.0318 15.179L22.9652 15.6745ZM19.7263 14.2519C20.6177 15.1432 21.728 15.5082 22.9652 15.6745L23.0318 15.179C21.8498 15.0201 20.8627 14.6812 20.0799 13.8983L19.7263 14.2519ZM18.3037 11.013C18.47 12.2502 18.835 13.3605 19.7263 14.2519L20.0799 13.8983C19.297 13.1155 18.9581 12.1284 18.7992 10.9464L18.3037 11.013ZM18.1459 6.56311C18.1459 8.35035 18.1453 9.83544 18.3037 11.013L18.7992 10.9464C18.6464 9.80957 18.6459 8.36319 18.6459 6.56312L18.1459 6.56311ZM21.0209 6.47811V4.2764H20.5209V6.47811H21.0209ZM21.153 10.6299C21.024 9.67011 21.0209 8.38489 21.0209 6.47811H20.5209C20.5209 8.37042 20.5229 9.6956 20.6575 10.6966L21.153 10.6299ZM21.7593 12.2189C21.4911 11.9508 21.2765 11.5482 21.153 10.6299L20.6575 10.6966C20.7885 11.6707 21.0293 12.1961 21.4057 12.5725L21.7593 12.2189ZM23.3483 12.8252C22.43 12.7017 22.0274 12.4871 21.7593 12.2189L21.4057 12.5725C21.7821 12.9489 22.3075 13.1897 23.2816 13.3207L23.3483 12.8252ZM27.5001 12.9573C25.5933 12.9573 24.3081 12.9542 23.3483 12.8252L23.2816 13.3207C24.2826 13.4553 25.6078 13.4573 27.5001 13.4573V12.9573ZM30.6976 12.9573H27.5001V13.4573H30.6976V12.9573ZM28.6787 11.6895C29.4602 12.3929 30.0581 12.9352 30.5235 13.3867L30.8716 13.0278C30.3984 12.5687 29.7935 12.0201 29.0131 11.3178L28.6787 11.6895ZM22.4106 6.0482L28.6787 11.6895L29.0131 11.3178L22.7451 5.67655L22.4106 6.0482ZM20.6121 4.46946C21.0734 4.84904 21.6412 5.35569 22.4106 6.0482L22.7451 5.67655C21.9775 4.98573 21.4013 4.47128 20.9298 4.08335L20.6121 4.46946ZM20.113 0.806432C18.7571 0.286128 17.2888 0.289985 15.1112 0.290567L15.1113 0.790567C17.3182 0.789977 18.6826 0.793076 19.9339 1.27324L20.113 0.806432ZM24.1639 3.75821C22.5532 2.30775 21.4689 1.32672 20.113 0.806432L19.9339 1.27324C21.1852 1.75342 22.197 2.6599 23.8293 4.12976L24.1639 3.75821ZM24.3339 3.91123C24.2765 3.85962 24.2199 3.80862 24.1639 3.7582L23.8293 4.12976C23.8853 4.18016 23.942 4.23121 23.9994 4.28288L24.3339 3.91123ZM30.6019 9.55248L24.3339 3.91123L23.9994 4.28288L30.2675 9.92413L30.6019 9.55248ZM30.7996 9.73035C30.7345 9.67178 30.6686 9.61251 30.6019 9.55248L30.2675 9.92413C30.3342 9.98421 30.4002 10.0435 30.4653 10.1021L30.7996 9.73035ZM34.5987 14.0539C33.9207 12.5315 32.661 11.4046 30.7996 9.73035L30.4653 10.1021C32.3522 11.7993 33.5163 12.8524 34.142 14.2573L34.5987 14.0539ZM35.271 19.7701C35.2717 17.2665 35.2768 15.5764 34.5987 14.0539L34.142 14.2573C34.7677 15.6623 34.7717 17.2321 34.771 19.7699L35.271 19.7701ZM35.2709 20.036C35.2709 19.9463 35.2709 19.8577 35.271 19.7701L34.771 19.7699C34.7709 19.8575 34.7709 19.9462 34.7709 20.036H35.2709ZM35.0262 27.869C35.2715 26.0449 35.2709 23.7206 35.2709 20.8174L34.7709 20.8174C34.7709 23.7339 34.7704 26.0191 34.5307 27.8024L35.0262 27.869ZM32.9949 32.5563C34.234 31.3171 34.7729 29.753 35.0262 27.869L34.5307 27.8024C34.2848 29.6311 33.772 31.072 32.6413 32.2027L32.9949 32.5563ZM28.3077 34.5876C30.1917 34.3343 31.7558 33.7954 32.9949 32.5563L32.6413 32.2027C31.5107 33.3334 30.0697 33.8462 28.2411 34.092L28.3077 34.5876ZM21.2561 34.8323C24.1592 34.8323 26.4835 34.8328 28.3077 34.5876L28.2411 34.092C26.4577 34.3318 24.1725 34.3323 21.2561 34.3323L21.2561 34.8323ZM7.69248 34.5876C9.51667 34.8328 11.841 34.8323 14.7441 34.8323L14.7441 34.3323C11.8277 34.3323 9.54243 34.3318 7.75911 34.092L7.69248 34.5876ZM3.00527 32.5563C4.24441 33.7954 5.8085 34.3343 7.69248 34.5876L7.75911 34.092C5.93042 33.8462 4.48951 33.3334 3.35883 32.2027L3.00527 32.5563ZM0.973941 27.869C1.22724 29.753 1.76614 31.3171 3.00527 32.5563L3.35883 32.2027C2.22815 31.072 1.71534 29.6311 1.46948 27.8024L0.973941 27.869ZM0.729249 20.8174C0.729224 23.7206 0.728686 26.0449 0.973941 27.869L1.46948 27.8024C1.22972 26.0191 1.22922 23.7339 1.22925 20.8174L0.729249 20.8174ZM0.973941 7.25384C0.728686 9.07803 0.729224 11.4023 0.729249 14.3054L1.22925 14.3054C1.22922 11.389 1.22972 9.10379 1.46948 7.32047L0.973941 7.25384ZM3.00527 2.56663C1.76614 3.80577 1.22724 5.36986 0.973941 7.25384L1.46948 7.32047C1.71534 5.49178 2.22815 4.05086 3.35883 2.92019L3.00527 2.56663ZM7.70513 0.535185C5.81489 0.788169 4.24553 1.32637 3.00527 2.56663L3.35883 2.92019C4.49024 1.78877 5.93595 1.27642 7.77146 1.03077L7.70513 0.535185ZM14.7915 0.290607C11.8724 0.290582 9.53674 0.290049 7.70513 0.535185L7.77146 1.03077C9.56238 0.791076 11.8591 0.790582 14.7915 0.790607L14.7915 0.290607ZM14.8806 0.290608L14.7915 0.290607L14.7915 0.790607L14.8806 0.790608L14.8806 0.290608ZM15.1112 0.290567C15.0352 0.290587 14.9584 0.290608 14.8806 0.290608V0.790608C14.9585 0.790608 15.0354 0.790587 15.1113 0.790567L15.1112 0.290567ZM27.4151 15.8323H32.3707V15.3323H27.4151V15.8323ZM18.1459 3.04887V6.56311H18.6459V3.04887H18.1459ZM35.2709 20.8174V20.036H34.7709V20.8174H35.2709ZM14.7441 34.8323H21.2561V34.3323H14.7441V34.8323ZM0.729249 14.3054V20.8174H1.22925V14.3054H0.729249Z"
                        fill="#003DA6"
                      />
                    </svg>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    className="desc">
                    Britannia Pharmacy brings professional healthcare closer to
                    you with our certified ability to prescribe treatments for
                    16 common health conditions. 
                  </motion.p>
                </div>
                <div className="box">
                  <motion.div
                    initial={{ opacity: 0, x: -50, y: -30 }}
                    whileInView={{ opacity: 1, x: 0, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}
                    className="imagewrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="37"
                      viewBox="0 0 37 37"
                      fill="none">
                      <path
                        d="M15.0004 5.64478H18.3337C19.0241 5.64478 19.5837 6.20442 19.5837 6.89478C19.5837 7.58513 19.0241 8.14478 18.3337 8.14478H15.0004C14.3101 8.14478 13.7504 7.58513 13.7504 6.89478C13.7504 6.20442 14.3101 5.64478 15.0004 5.64478Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M14.5722 13.8788C14.6665 14.5627 14.1886 15.1935 13.5047 15.2878L13.5027 15.2881L13.5005 15.2884L13.4955 15.2891L13.4831 15.2907L13.4491 15.2947C13.4224 15.2977 13.3878 15.3012 13.3458 15.3047C13.2619 15.3116 13.1481 15.3186 13.0099 15.3211C12.7351 15.326 12.3554 15.3134 11.9187 15.2438C11.0521 15.1058 9.89093 14.7313 8.91454 13.7549C7.93815 12.7785 7.56367 11.6174 7.42567 10.7508C7.35611 10.314 7.34342 9.93438 7.34836 9.65957C7.35085 9.52141 7.35783 9.40759 7.36481 9.32372C7.3683 9.28171 7.37181 9.24703 7.37479 9.22036L7.3788 9.18636L7.38039 9.17398C7.4747 8.49009 8.10679 8.00292 8.79068 8.09722C9.47148 8.19111 9.9482 8.81672 9.85944 9.49704C9.79888 10.6014 10.3767 12.81 13.1724 12.81C13.8528 12.7213 14.4784 13.198 14.5722 13.8788Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M16.6165 11.8442C17.1047 11.3561 17.8961 11.3561 18.3843 11.8442L20.051 13.5109C20.5391 13.999 20.5391 14.7905 20.051 15.2787C19.5628 15.7668 18.7713 15.7668 18.2832 15.2787L16.6165 13.612C16.1284 13.1238 16.1284 12.3324 16.6165 11.8442Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M23.7504 18.5614C23.7504 17.8711 23.1908 17.3114 22.5004 17.3114C21.8101 17.3114 21.2504 17.8711 21.2504 18.5614V21.8948C21.2504 22.5851 21.8101 23.1448 22.5004 23.1448C23.1908 23.1448 23.7504 22.5851 23.7504 21.8948V18.5614Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M27.4546 27.8375L27.4523 27.8355L27.4498 27.8333L27.4445 27.8287L27.4324 27.8178L27.4021 27.7898C27.3794 27.7684 27.3517 27.7414 27.32 27.7088C27.2567 27.6437 27.1768 27.5556 27.0883 27.4442C26.9116 27.222 26.6971 26.9029 26.5132 26.4858C26.137 25.6323 25.9165 24.428 26.3205 22.9199C26.7246 21.4118 27.5177 20.4789 28.2704 19.9279C28.6382 19.6587 28.9835 19.4896 29.2476 19.3855C29.38 19.3333 29.4932 19.297 29.5806 19.2722C29.6244 19.2598 29.6619 19.2503 29.6922 19.2431L29.7324 19.234L29.7484 19.2307L29.7553 19.2293L29.7585 19.2286C29.7585 19.2286 29.7616 19.2281 30.0006 20.455L29.7616 19.228C30.4392 19.096 31.0955 19.5384 31.2275 20.216C31.3578 20.8848 30.9286 21.5329 30.2659 21.6765L30.2615 21.6777C30.2468 21.6819 30.2127 21.6923 30.1642 21.7114C30.0666 21.7499 29.916 21.8215 29.7472 21.9451C29.4265 22.1799 28.9834 22.6412 28.7354 23.5669C28.4874 24.4925 28.6405 25.1137 28.8008 25.4773C28.8852 25.6688 28.9798 25.8062 29.0451 25.8883C29.0775 25.9291 29.1018 25.9551 29.1125 25.9661L29.1157 25.9693C29.6177 26.4251 29.6654 27.2009 29.2181 27.715C28.765 28.2358 27.9754 28.2907 27.4546 27.8375Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M7.67876 16.5396C7.94286 15.9018 7.63989 15.1706 7.00205 14.9065C6.36421 14.6424 5.63304 14.9454 5.36893 15.5832L4.67883 17.2499C4.41473 17.8877 4.7177 18.6189 5.35554 18.883C5.99338 19.1471 6.72455 18.8442 6.98865 18.2063L7.67876 16.5396Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M22.6033 11.7534C21.923 11.8422 21.2974 11.3654 21.2035 10.6846C21.1092 10.0008 21.5964 9.36866 22.2803 9.27435C22.2803 9.27435 22.388 9.26226 22.43 9.25877C22.5139 9.25179 22.6277 9.24481 22.7658 9.24232C23.0407 9.23738 23.4203 9.25007 23.8571 9.31963C24.7237 9.45763 25.8848 9.83211 26.8612 10.8085C27.8376 11.7849 28.2121 12.946 28.3501 13.8126C28.4196 14.2494 28.4323 14.629 28.4274 14.9039C28.4249 15.042 28.4179 15.1558 28.4109 15.2397C28.4074 15.2817 28.4039 15.3164 28.4009 15.3431C28.3066 16.027 27.669 16.5605 26.9851 16.4662C26.3043 16.3723 25.8275 15.7467 25.9163 15.0664C25.9163 12.2704 23.7077 11.6927 22.6033 11.7534Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M21.4694 27.1948C20.9245 26.7709 20.1391 26.869 19.7153 27.4139C19.2914 27.9588 19.3895 28.7442 19.9344 29.168L22.5655 31.2147C23.1104 31.6386 23.8957 31.5404 24.3196 30.9955C24.7435 30.4506 24.6453 29.6653 24.1004 29.2414L21.4694 27.1948Z"
                        fill="#003DA6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.3334 17.3114C9.88164 17.3114 7.08341 20.1097 7.08341 23.5614C7.08341 27.0132 9.88164 29.8114 13.3334 29.8114C16.7852 29.8114 19.5834 27.0132 19.5834 23.5614C19.5834 20.1097 16.7852 17.3114 13.3334 17.3114ZM9.58341 23.5614C9.58341 21.4904 11.2623 19.8114 13.3334 19.8114C15.4045 19.8114 17.0834 21.4904 17.0834 23.5614C17.0834 25.6325 15.4045 27.3114 13.3334 27.3114C11.2623 27.3114 9.58341 25.6325 9.58341 23.5614Z"
                        fill="#003DA6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.416748 18.5614C0.416748 8.66634 8.43831 0.644775 18.3334 0.644775C28.2285 0.644775 36.2501 8.66634 36.2501 18.5614C36.2501 28.4565 28.2285 36.4781 18.3334 36.4781C8.43831 36.4781 0.416748 28.4565 0.416748 18.5614ZM18.3334 3.14478C9.81902 3.14478 2.91675 10.0471 2.91675 18.5614C2.91675 27.0758 9.81902 33.9781 18.3334 33.9781C26.8478 33.9781 33.7501 27.0758 33.7501 18.5614C33.7501 10.0471 26.8478 3.14478 18.3334 3.14478Z"
                        fill="#003DA6"
                      />
                      <path
                        d="M7.38039 9.17398L7.3788 9.18636L7.37479 9.22036C7.37181 9.24703 7.3683 9.28171 7.36481 9.32372C7.35783 9.40759 7.35085 9.52141 7.34836 9.65957C7.34342 9.93438 7.35611 10.314 7.42567 10.7508C7.56367 11.6174 7.93815 12.7785 8.91454 13.7549C9.89093 14.7313 11.0521 15.1058 11.9187 15.2438C12.3554 15.3134 12.7351 15.326 13.0099 15.3211C13.1481 15.3186 13.2619 15.3116 13.3458 15.3047C13.3878 15.3012 13.4224 15.2977 13.4491 15.2947L13.4831 15.2907L13.4955 15.2891L13.5005 15.2884L13.5027 15.2881L13.5047 15.2878C14.1886 15.1935 14.6665 14.5627 14.5722 13.8788C14.4784 13.198 13.8528 12.7213 13.1724 12.81C10.3767 12.81 9.79888 10.6014 9.85944 9.49704C9.9482 8.81672 9.47148 8.19111 8.79068 8.09722C8.10679 8.00292 7.4747 8.49009 7.38039 9.17398ZM7.38039 9.17398L7.38106 9.16896L7.38136 9.16675M28.4009 15.3431C28.4039 15.3164 28.4074 15.2817 28.4109 15.2397C28.4179 15.1558 28.4249 15.042 28.4274 14.9039C28.4323 14.629 28.4196 14.2494 28.3501 13.8126C28.2121 12.946 27.8376 11.7849 26.8612 10.8085C25.8848 9.83211 24.7237 9.45763 23.8571 9.31963C23.4203 9.25007 23.0407 9.23738 22.7658 9.24232C22.6277 9.24481 22.5139 9.25179 22.43 9.25877C22.388 9.26226 22.2803 9.27435 22.2803 9.27435C21.5964 9.36866 21.1092 10.0008 21.2035 10.6846C21.2974 11.3654 21.923 11.8422 22.6033 11.7534C23.7077 11.6927 25.9163 12.2704 25.9163 15.0664C25.8275 15.7467 26.3043 16.3723 26.9851 16.4662C27.669 16.5605 28.3066 16.027 28.4009 15.3431ZM28.4009 15.3431L28.3969 15.3771L28.3953 15.3894L28.3947 15.3945L28.3944 15.3967M2.91675 18.5614C2.91675 10.0471 9.81902 3.14478 18.3334 3.14478C26.8478 3.14478 33.7501 10.0471 33.7501 18.5614C33.7501 27.0758 26.8478 33.9781 18.3334 33.9781C9.81902 33.9781 2.91675 27.0758 2.91675 18.5614ZM18.3334 0.644775C8.43831 0.644775 0.416748 8.66634 0.416748 18.5614C0.416748 28.4565 8.43831 36.4781 18.3334 36.4781C28.2285 36.4781 36.2501 28.4565 36.2501 18.5614C36.2501 8.66634 28.2285 0.644775 18.3334 0.644775ZM18.3337 5.64478H15.0004C14.3101 5.64478 13.7504 6.20442 13.7504 6.89478C13.7504 7.58513 14.3101 8.14478 15.0004 8.14478H18.3337C19.0241 8.14478 19.5837 7.58513 19.5837 6.89478C19.5837 6.20442 19.0241 5.64478 18.3337 5.64478ZM18.3843 11.8442C17.8961 11.3561 17.1047 11.3561 16.6165 11.8442C16.1284 12.3324 16.1284 13.1238 16.6165 13.612L18.2832 15.2787C18.7713 15.7668 19.5628 15.7668 20.051 15.2787C20.5391 14.7905 20.5391 13.999 20.051 13.5109L18.3843 11.8442ZM22.5004 17.3114C23.1908 17.3114 23.7504 17.8711 23.7504 18.5614V21.8948C23.7504 22.5851 23.1908 23.1448 22.5004 23.1448C21.8101 23.1448 21.2504 22.5851 21.2504 21.8948V18.5614C21.2504 17.8711 21.8101 17.3114 22.5004 17.3114ZM27.4523 27.8355L27.4546 27.8375C27.9754 28.2907 28.765 28.2358 29.2181 27.715C29.6654 27.2009 29.6177 26.4251 29.1157 25.9693L29.1125 25.9661C29.1018 25.9551 29.0775 25.9291 29.0451 25.8883C28.9798 25.8062 28.8852 25.6688 28.8008 25.4773C28.6405 25.1137 28.4874 24.4925 28.7354 23.5669C28.9834 22.6412 29.4265 22.1799 29.7472 21.9451C29.916 21.8215 30.0666 21.7499 30.1642 21.7114C30.2127 21.6923 30.2468 21.6819 30.2615 21.6777L30.2659 21.6765C30.9286 21.5329 31.3578 20.8848 31.2275 20.216C31.0955 19.5384 30.4392 19.096 29.7616 19.228L30.0006 20.455C29.7616 19.228 29.7585 19.2286 29.7585 19.2286L29.7553 19.2293L29.7484 19.2307L29.7324 19.234L29.6922 19.2431C29.6619 19.2503 29.6244 19.2598 29.5806 19.2722C29.4932 19.297 29.38 19.3333 29.2476 19.3855C28.9835 19.4896 28.6382 19.6587 28.2704 19.9279C27.5177 20.4789 26.7246 21.4118 26.3205 22.9199C25.9165 24.428 26.137 25.6323 26.5132 26.4858C26.6971 26.9029 26.9116 27.222 27.0883 27.4442C27.1768 27.5556 27.2567 27.6437 27.32 27.7088C27.3517 27.7414 27.3794 27.7684 27.4021 27.7898L27.4324 27.8178L27.4445 27.8287L27.4498 27.8333L27.4523 27.8355ZM7.00205 14.9065C7.63989 15.1706 7.94286 15.9018 7.67876 16.5396L6.98865 18.2063C6.72455 18.8442 5.99338 19.1471 5.35554 18.883C4.7177 18.6189 4.41473 17.8877 4.67883 17.2499L5.36893 15.5832C5.63304 14.9454 6.36421 14.6424 7.00205 14.9065ZM19.7153 27.4139C20.1391 26.869 20.9245 26.7709 21.4694 27.1948L24.1004 29.2414C24.6453 29.6653 24.7435 30.4506 24.3196 30.9955C23.8957 31.5404 23.1104 31.6386 22.5655 31.2147L19.9344 29.168C19.3895 28.7442 19.2914 27.9588 19.7153 27.4139ZM13.3334 19.8114C11.2623 19.8114 9.58341 21.4904 9.58341 23.5614C9.58341 25.6325 11.2623 27.3114 13.3334 27.3114C15.4045 27.3114 17.0834 25.6325 17.0834 23.5614C17.0834 21.4904 15.4045 19.8114 13.3334 19.8114ZM7.08341 23.5614C7.08341 20.1097 9.88164 17.3114 13.3334 17.3114C16.7852 17.3114 19.5834 20.1097 19.5834 23.5614C19.5834 27.0132 16.7852 29.8114 13.3334 29.8114C9.88164 29.8114 7.08341 27.0132 7.08341 23.5614Z"
                        stroke="#003DA6"
                        stroke-width="0.5"
                      />
                    </svg>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    className="desc">
                    From seasonal allergies to skin conditions, our expert
                    pharmacists are equipped to provide personalized care and
                    prescriptions for a range of common health issues. 
                  </motion.p>
                </div>
                <div className="box">
                  <motion.div
                    initial={{ opacity: 0, x: -50, y: -30 }}
                    whileInView={{ opacity: 1, x: 0, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4, delay: 0.2 }}
                    className="imagewrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="37"
                      viewBox="0 0 37 37"
                      fill="none">
                      <path
                        d="M18.6667 2.89478C10.0142 2.89478 3 9.90898 3 18.5614C3 27.2139 10.0142 34.2281 18.6667 34.2281C27.3191 34.2281 34.3333 27.2139 34.3333 18.5614C34.3333 9.90898 27.3191 2.89478 18.6667 2.89478ZM1 18.5614C1 8.80441 8.90964 0.894775 18.6667 0.894775C28.4237 0.894775 36.3333 8.80441 36.3333 18.5614C36.3333 28.3185 28.4237 36.2281 18.6667 36.2281C8.90964 36.2281 1 28.3185 1 18.5614ZM12.8633 24.6326C13.1922 24.1889 13.8185 24.0959 14.2622 24.4247C15.5167 25.3547 17.0337 25.8948 18.6667 25.8948C20.2997 25.8948 21.8166 25.3547 23.0712 24.4247C23.5149 24.0959 24.1412 24.1889 24.47 24.6326C24.7989 25.0763 24.7058 25.7026 24.2621 26.0315C22.6821 27.2026 20.7518 27.8948 18.6667 27.8948C16.5816 27.8948 14.6512 27.2026 13.0712 26.0315C12.6275 25.7026 12.5344 25.0763 12.8633 24.6326ZM25.0833 16.0614C25.0833 16.7093 24.9078 17.2846 24.6372 17.6905C24.3654 18.0982 24.0173 18.3114 23.6667 18.3114C23.316 18.3114 22.968 18.0982 22.6962 17.6905C22.4255 17.2846 22.25 16.7093 22.25 16.0614C22.25 15.4136 22.4255 14.8383 22.6962 14.4323C22.968 14.0246 23.316 13.8114 23.6667 13.8114C24.0173 13.8114 24.3654 14.0246 24.6372 14.4323C24.9078 14.8383 25.0833 15.4136 25.0833 16.0614ZM15.0833 16.0614C15.0833 16.7093 14.9078 17.2846 14.6372 17.6905C14.3654 18.0982 14.0173 18.3114 13.6667 18.3114C13.316 18.3114 12.968 18.0982 12.6962 17.6905C12.4255 17.2846 12.25 16.7093 12.25 16.0614C12.25 15.4136 12.4255 14.8383 12.6962 14.4323C12.968 14.0246 13.316 13.8114 13.6667 13.8114C14.0173 13.8114 14.3654 14.0246 14.6372 14.4323C14.9078 14.8383 15.0833 15.4136 15.0833 16.0614Z"
                        fill="#003DA6"
                        stroke="#003DA6"
                        stroke-width="0.5"
                      />
                    </svg>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.4 }}
                    className="desc">
                    Experience convenient, compassionate care for your everyday
                    health needs.
                  </motion.p>
                </div>
              </div>
              <Link className="ctabutton" to="/MinorAliments">
                Discover Our Ailment Care
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none">
                  <path
                    d="M5 12H19"
                    stroke="#003DA6"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 5L19 12L12 19"
                    stroke="#003DA6"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        )}
      </InView>
      <InView
        as="div"
        style={{ width: "-webkit-fill-available" }}
        onChange={(inView) => handleInView("SectionSeven", inView)}
        triggerOnce>
        <div className="SectionSix">
          <div className="wrap">
            <img src={Doc} alt="Doc" className="left" />
            <div className="right">
              <div className="upper">
                <p className="note">
                  Two Decades of Trusted Care: Meet Raafat Khalil
                </p>
                <p className="heading">
                  Experience and Dedication at the Heart of Britannia Pharmacy
                </p>
              </div>
              <div className="lower">
                <motion.div
                  initial={{ opacity: 0, x: -10, y: 10 }}
                  whileInView={{ opacity: 1, x: 0, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.3 }}
                  className="line"></motion.div>
                <div className="box">
                  <motion.p
                    initial={{ opacity: 0, y: -80 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{
                      ease: "easeOut",
                      duration: 0.3,
                      delay: 0.65,
                    }}
                    className="nubmer">
                    01
                  </motion.p>
                  <p className="desc">
                    Since 2002, Britannia Pharmacy has been a cornerstone of
                    healthcare in our community, guided by the expertise and
                    dedication of Raafat Khalil. 
                  </p>
                </div>
                <div className="box">
                  <motion.p
                    initial={{ opacity: 0, y: -80 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{
                      ease: "easeOut",
                      duration: 0.3,
                      delay: 0.32,
                    }}
                    className="nubmer">
                    02
                  </motion.p>
                  <p className="desc">
                    With over 20 years in the pharmaceutical field, Raafat has
                    built a pharmacy that dispenses medication and offers
                    personalized care and advice. 
                  </p>
                </div>
                <div className="box">
                  <motion.p
                    initial={{ opacity: 0, y: -80 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.8 }}
                    transition={{ ease: "easeOut", duration: 0.3 }}
                    className="nubmer">
                    03
                  </motion.p>
                  <p className="desc">
                    As the owner and manager, he ensures that every customer
                    receives the highest standard of service, rooted in deep
                    industry knowledge and a commitment to health and
                    well-being. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isInView.includes("SectionSeven") && (
          <div className="SectionSeven">
            <div className="wrap">
              <div className="upper">
                <motion.p
                  initial={{ opacity: 0, x: 60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="note">
                  Testimonials
                </motion.p>
                <motion.h2
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4 }}
                  className="heading">
                  Real Stories, {!Desktop && <br />} Real Impact: <br />{" "}
                  <span style={{ color: "#003DA6" }}>Our Customers Speak</span>
                </motion.h2>
              </div>
              <TestimonialsSwiper />
            </div>
          </div>
        )}
        {isInView.includes("SectionSeven") && (
          <div className="SectionEight">
            <div className="wrap">
              <div className="upper">
                <p className="note">Stay Connected with Britannia Pharmacy</p>
                <h2 className="heading">
                  Your Local Pharmacy,
                  <br />{" "}
                  <span style={{ color: "#003DA6" }}>Always Here to Help</span>
                </h2>
              </div>
              <div className="lower">
                <img src={pharmacy} alt="pharmacy" className="left" />
                {Desktop ? (
                  <div className="right">
                    <div className="whitebox">
                      <motion.svg
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.8 }}
                        transition={{ ease: "easeOut", duration: 0.4 }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="36"
                        viewBox="0 0 35 36"
                        fill="none">
                        <path
                          d="M5.83329 6.39502H29.1666C30.7708 6.39502 32.0833 7.70752 32.0833 9.31169V26.8117C32.0833 28.4159 30.7708 29.7284 29.1666 29.7284H5.83329C4.22913 29.7284 2.91663 28.4159 2.91663 26.8117V9.31169C2.91663 7.70752 4.22913 6.39502 5.83329 6.39502Z"
                          stroke="#003DA6"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M32.0833 9.31152L17.5 19.5199L2.91663 9.31152"
                          stroke="#003DA6"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </motion.svg>
                      <div className="text">
                        <motion.p
                          initial={{ opacity: 0, x: -50, y: -30 }}
                          whileInView={{ opacity: 1, x: 0, y: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{
                            ease: "easeOut",
                            duration: 0.4,
                            delay: 0.4,
                          }}
                          className="title">
                          Get in Touch
                        </motion.p>
                        <motion.p
                          initial={{ opacity: 0, x: -50 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{ ease: "easeOut", duration: 0.4 }}
                          className="desc">
                          Phone: 905-286-4830 <br />
                          Fax: 905-286-4851 <br />
                          Email: britanniapharmacy11@gmail.com
                        </motion.p>
                      </div>
                    </div>
                    <div className="whitebox">
                      <motion.svg
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.8 }}
                        transition={{ ease: "easeOut", duration: 0.4 }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="36"
                        viewBox="0 0 35 36"
                        fill="none">
                        <path
                          d="M17.5 32.6447C25.5541 32.6447 32.0833 26.1155 32.0833 18.0614C32.0833 10.0072 25.5541 3.47803 17.5 3.47803C9.44581 3.47803 2.91663 10.0072 2.91663 18.0614C2.91663 26.1155 9.44581 32.6447 17.5 32.6447Z"
                          stroke="#003DA6"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.5 9.31152V18.0615L23.3333 20.9782"
                          stroke="#003DA6"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </motion.svg>
                      <div className="text">
                        <motion.p
                          initial={{ opacity: 0, x: -50, y: -30 }}
                          whileInView={{ opacity: 1, x: 0, y: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{
                            ease: "easeOut",
                            duration: 0.4,
                            delay: 0.4,
                          }}
                          className="title">
                          Hours of Operation
                        </motion.p>
                        <motion.p
                          initial={{ opacity: 0, x: -50 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{ ease: "easeOut", duration: 0.4 }}
                          className="desc">
                          Monday to Friday: 9:30 AM - 6:30 PM <br />
                          Saturday: 9:00 AM - 3:00 PM <br />
                          Sunday and Holidays: Closed
                        </motion.p>
                      </div>
                    </div>
                    <div className="whitebox">
                      <motion.svg
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.8 }}
                        transition={{ ease: "easeOut", duration: 0.4 }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="36"
                        viewBox="0 0 35 36"
                        fill="none">
                        <g clip-path="url(#clip0_67_2715)">
                          <path
                            d="M30.625 15.145C30.625 25.3534 17.5 34.1034 17.5 34.1034C17.5 34.1034 4.375 25.3534 4.375 15.145C4.375 11.6641 5.75781 8.32566 8.21922 5.86424C10.6806 3.40283 14.019 2.02002 17.5 2.02002C20.981 2.02002 24.3194 3.40283 26.7808 5.86424C29.2422 8.32566 30.625 11.6641 30.625 15.145Z"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.5 19.52C19.9162 19.52 21.875 17.5613 21.875 15.145C21.875 12.7288 19.9162 10.77 17.5 10.77C15.0838 10.77 13.125 12.7288 13.125 15.145C13.125 17.5613 15.0838 19.52 17.5 19.52Z"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_67_2715">
                            <rect
                              width="35"
                              height="35"
                              fill="white"
                              transform="translate(0 0.561523)"
                            />
                          </clipPath>
                        </defs>
                      </motion.svg>
                      <div className="text">
                        <motion.p
                          initial={{ opacity: 0, x: -50, y: -30 }}
                          whileInView={{ opacity: 1, x: 0, y: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{
                            ease: "easeOut",
                            duration: 0.4,
                            delay: 0.4,
                          }}
                          className="title">
                          Location
                        </motion.p>
                        <motion.p
                          initial={{ opacity: 0, x: -50 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true, amount: 0.8 }}
                          transition={{ ease: "easeOut", duration: 0.4 }}
                          className="desc">
                          5980 Churchill Meadows Blvd <br /> #11, Mississauga,
                          ON L5M 7M5
                        </motion.p>
                      </div>
                    </div>
                    {Desktop && (
                      <Link className="ctaButton" to="/Contact">
                        Contact Us{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none">
                          <path
                            d="M5 12.5615H19"
                            stroke="#003DA6"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 5.56152L19 12.5615L12 19.5615"
                            stroke="#003DA6"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                ) : (
                  <div className="right mobile">
                    <div className="whitebox">
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="36"
                          viewBox="0 0 35 36"
                          fill="none">
                          <path
                            d="M5.83329 6.39502H29.1666C30.7708 6.39502 32.0833 7.70752 32.0833 9.31169V26.8117C32.0833 28.4159 30.7708 29.7284 29.1666 29.7284H5.83329C4.22913 29.7284 2.91663 28.4159 2.91663 26.8117V9.31169C2.91663 7.70752 4.22913 6.39502 5.83329 6.39502Z"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M32.0833 9.31152L17.5 19.5199L2.91663 9.31152"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <p className="title">Get in Touch</p>
                      </div>
                      <p className="desc">
                        Phone: 905-286-4830 <br />
                        Fax: 905-286-4851 <br />
                        Email: britanniapharmacy11@gmail.com
                      </p>
                    </div>
                    <div className="whitebox">
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="36"
                          viewBox="0 0 35 36"
                          fill="none">
                          <path
                            d="M17.5 32.6447C25.5541 32.6447 32.0833 26.1155 32.0833 18.0614C32.0833 10.0072 25.5541 3.47803 17.5 3.47803C9.44581 3.47803 2.91663 10.0072 2.91663 18.0614C2.91663 26.1155 9.44581 32.6447 17.5 32.6447Z"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.5 9.31152V18.0615L23.3333 20.9782"
                            stroke="#003DA6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <p className="title">Hours of Operation</p>
                      </div>
                      <p className="desc">
                        Monday to Friday: 9:30 AM - 6:30 PM <br />
                        Saturday: 9:00 AM - 3:00 PM <br />
                        Sunday and Holidays: Closed
                      </p>
                    </div>
                    <div className="whitebox">
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="36"
                          viewBox="0 0 35 36"
                          fill="none">
                          <g clip-path="url(#clip0_67_2715)">
                            <path
                              d="M30.625 15.145C30.625 25.3534 17.5 34.1034 17.5 34.1034C17.5 34.1034 4.375 25.3534 4.375 15.145C4.375 11.6641 5.75781 8.32566 8.21922 5.86424C10.6806 3.40283 14.019 2.02002 17.5 2.02002C20.981 2.02002 24.3194 3.40283 26.7808 5.86424C29.2422 8.32566 30.625 11.6641 30.625 15.145Z"
                              stroke="#003DA6"
                              stroke-width="2.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.5 19.52C19.9162 19.52 21.875 17.5613 21.875 15.145C21.875 12.7288 19.9162 10.77 17.5 10.77C15.0838 10.77 13.125 12.7288 13.125 15.145C13.125 17.5613 15.0838 19.52 17.5 19.52Z"
                              stroke="#003DA6"
                              stroke-width="2.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_67_2715">
                              <rect
                                width="35"
                                height="35"
                                fill="white"
                                transform="translate(0 0.561523)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <p className="title">Location</p>
                      </div>
                      <p className="desc">
                        5980 Churchill Meadows Blvd <br /> #11, Mississauga, ON
                        L5M 7M5
                      </p>
                    </div>
                    {Desktop && (
                      <Link className="ctaButton" to="/Contact">
                        Contact Us{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none">
                          <path
                            d="M5 12.5615H19"
                            stroke="#003DA6"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 5.56152L19 12.5615L12 19.5615"
                            stroke="#003DA6"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                )}
              </div>
              {!Desktop && (
                <Link className="ctaButton" to="/Contact">
                  Contact Us{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none">
                    <path
                      d="M5 12.5615H19"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 5.56152L19 12.5615L12 19.5615"
                      stroke="#003DA6"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Link>
              )}
            </div>
          </div>
        )}
        {isInView.includes("SectionSeven") && (
          <div className="SectionNine">
            <div className="wrap">
              <div className="card">
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="45"
                    viewBox="0 0 44 45"
                    fill="none">
                    <g clip-path="url(#clip0_359_2472)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M40.347 22.5435L32.9143 22.549C33.0354 22.8937 33.1026 23.2648 33.1037 23.6502V24.3549C33.1037 25.4418 32.5806 26.4064 31.7713 27.0087C32.0906 27.5152 32.2745 28.1164 32.2756 28.7595V29.4642C32.2761 29.8981 32.191 30.3279 32.0253 30.7289C31.8596 31.1299 31.6166 31.4944 31.31 31.8015C31.0035 32.1085 30.6394 32.3522 30.2386 32.5186C29.8379 32.6849 29.4083 32.7707 28.9744 32.771H28.3787C28.4998 33.1156 28.567 33.4867 28.567 33.8721L28.5681 34.5769C28.5685 35.0108 28.4834 35.4405 28.3178 35.8415C28.1521 36.2426 27.909 36.607 27.6025 36.9141C27.2959 37.2212 26.9318 37.4648 26.5311 37.6312C26.1303 37.7975 25.7007 37.8833 25.2668 37.8836L13.0849 37.8935C5.84155 37.899 -0.0352602 32.0321 -0.0407659 24.7888C-0.0432543 22.0946 0.784057 19.4651 2.32867 17.2577C3.87329 15.0503 6.06026 13.3722 8.59221 12.4516L21.785 7.65607C22.4243 7.42362 23.117 7.37975 23.7805 7.52968C24.444 7.6796 25.0505 8.01701 25.5278 8.50175C27.3381 10.3407 26.6422 13.4349 24.2196 14.3246L21.7035 15.2463L40.3415 15.2319C41.3111 15.2312 42.2412 15.6157 42.9273 16.3008C43.6135 16.9858 43.9993 17.9154 44.0001 18.885C44.0008 19.8546 43.6163 20.7847 42.9312 21.4708C42.2462 22.157 41.3166 22.5428 40.347 22.5435ZM40.3426 17.4342C40.7281 17.4339 41.0979 17.5868 41.3707 17.8592C41.6435 18.1316 41.7969 18.5011 41.7972 18.8866C41.7975 19.2721 41.6446 19.642 41.3723 19.9148C41.0999 20.1875 40.7303 20.341 40.3448 20.3413H39.5938C39.5954 20.3141 39.5962 20.287 39.596 20.2598V20.2532C39.596 19.3414 38.6094 18.6014 37.3937 18.6036C36.177 18.6036 35.1915 19.3447 35.1915 20.2565C35.1915 20.2862 35.1926 20.3159 35.1948 20.3446L23.6493 20.3545L23.6515 22.5568L29.7991 22.5513C30.0912 22.5513 30.3713 22.6673 30.5778 22.8738C30.7843 23.0803 30.9003 23.3604 30.9003 23.6524L30.9014 24.3571C30.9014 24.6492 30.7854 24.9293 30.5789 25.1358C30.3724 25.3423 30.0923 25.4583 29.8002 25.4583L23.6537 25.4638L23.6559 27.6661L28.9711 27.6617C29.2631 27.6617 29.5432 27.7777 29.7497 27.9842C29.9562 28.1907 30.0722 28.4708 30.0722 28.7628L30.0733 29.4664C30.0733 29.7585 29.9573 30.0386 29.7508 30.2451C29.5443 30.4516 29.2642 30.5676 28.9722 30.5676L21.1475 30.5753L21.1497 32.7776L25.2635 32.7743C25.5554 32.7743 25.8353 32.8901 26.0418 33.0964C26.2482 33.3027 26.3644 33.5825 26.3647 33.8743L26.3658 34.5791C26.3658 34.8711 26.2498 35.1512 26.0433 35.3577C25.8368 35.5642 25.5567 35.6802 25.2646 35.6802L13.0827 35.6912C7.05611 35.6956 2.16593 30.8131 2.16152 24.7866C2.15962 22.5449 2.84815 20.357 4.13349 18.5204C5.41883 16.6838 7.23861 15.2876 9.34539 14.5217L22.5371 9.72622C22.8694 9.61682 23.2313 9.64094 23.5462 9.7935C23.8611 9.94606 24.1043 10.2151 24.2244 10.5437C24.3445 10.8723 24.3322 11.2348 24.1899 11.5545C24.0476 11.8741 23.7866 12.1259 23.4621 12.2567L20.9448 13.1794C18.6335 14.0273 19.2436 17.4519 21.7046 17.4485L40.3426 17.4342Z"
                        fill="white"
                      />
                      <path
                        d="M37.4048 32.9176C39.2547 32.9176 40.7071 31.5301 40.706 29.7683C40.7038 28.1331 37.397 24.1084 37.397 24.1084C37.397 24.1084 34.0969 28.0131 34.0991 29.7749C34.0991 31.5367 35.5548 32.9198 37.4048 32.9176Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_359_2472">
                        <rect
                          width="44"
                          height="44"
                          fill="white"
                          transform="translate(0 0.561523)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="right">
                  <p className="title">Blood Pressure & Diabetes</p>
                  <p className="desc">Complimentary monitoring services </p>
                </motion.div>
              </div>
              <div className="card">
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none">
                    <path
                      d="M22.6666 28.0612C29.7542 28.0612 35.4999 22.3155 35.4999 15.2279C35.4999 8.14021 29.7542 2.39453 22.6666 2.39453C15.5789 2.39453 9.83325 8.14021 9.83325 15.2279C9.83325 22.3155 15.5789 28.0612 22.6666 28.0612Z"
                      stroke="white"
                      stroke-width="2.44444"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.7183 26.0261L13.5 42.7278L22.6667 37.2278L31.8333 42.7278L29.615 26.0078"
                      stroke="white"
                      stroke-width="2.44444"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="right">
                  <p className="title">Experience</p>
                  <p className="desc">Over 20 years of expertise </p>
                </motion.div>
              </div>
              <div className="card">
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M28.9022 3.16445C31.3077 3.97394 32.8752 6.23724 32.8752 9.20453C32.8752 11.07 31.8147 12.7871 30.6329 14.157C29.4181 15.5652 27.8806 16.8289 26.5356 17.8093C26.478 17.8513 26.4209 17.8931 26.3642 17.9345C25.0588 18.8883 23.9819 19.6751 22.3335 19.6751C20.6851 19.6751 19.6083 18.8883 18.3029 17.9345C18.2462 17.893 18.1891 17.8513 18.1314 17.8093C16.7865 16.8289 15.2489 15.5652 14.0341 14.157C12.8524 12.7871 11.7919 11.07 11.7919 9.20456C11.7919 6.23725 13.3594 3.97395 15.7648 3.16445C17.8165 2.47401 20.2046 2.92974 22.3335 4.47945C24.4624 2.92974 26.8506 2.47401 28.9022 3.16445ZM28.0251 5.77082C26.8297 5.36853 25.0471 5.62879 23.264 7.26776C22.7379 7.75134 21.9291 7.75134 21.403 7.26776C19.62 5.62879 17.8374 5.36853 16.6419 5.77082C15.4952 6.15672 14.5419 7.26372 14.5419 9.20456C14.5419 10.0618 15.0635 11.1401 16.1164 12.3607C17.1362 13.5429 18.486 14.6646 19.7513 15.587C21.2971 16.7138 21.6644 16.9251 22.3335 16.9251C23.0027 16.9251 23.37 16.7138 24.9157 15.5871C26.1811 14.6646 27.5308 13.5429 28.5507 12.3607C29.6036 11.1402 30.1252 10.0618 30.1252 9.20453C30.1252 7.26371 29.1718 6.15672 28.0251 5.77082ZM16.254 27.0491C19.6747 26.3864 23.3365 26.5351 26.2995 28.3024C26.7157 28.5506 27.1058 28.8599 27.4462 29.2423C28.1353 30.0163 28.4911 30.9782 28.5079 31.9427C28.8586 31.7165 29.2098 31.4654 29.5667 31.1958L32.8799 28.693C34.5382 27.4402 36.9484 27.44 38.607 28.6924C40.1396 29.8496 40.7506 31.9264 39.6535 33.685C38.8737 34.9349 37.6994 36.6636 36.5044 37.7705C35.2964 38.8893 33.5771 39.83 32.2766 40.4578C30.6972 41.2201 28.9914 41.6415 27.3326 41.91C23.9425 42.4588 20.4148 42.3748 17.0627 41.6842C15.3496 41.3313 13.5694 41.1479 11.8101 41.1479H7.66686C6.90747 41.1479 6.29186 40.5322 6.29186 39.7729C6.29186 39.0135 6.90747 38.3979 7.66686 38.3979H11.8101C13.7573 38.3979 15.7234 38.6006 17.6176 38.9908C20.6463 39.6148 23.837 39.6901 26.8932 39.1954C28.4129 38.9494 29.832 38.5841 31.0812 37.9812C32.3341 37.3764 33.7428 36.5799 34.6357 35.7529C35.5387 34.9166 36.5493 33.4653 37.3203 32.2294C37.553 31.8564 37.5208 31.3181 36.9499 30.8871C36.2721 30.3752 35.2151 30.3754 34.5375 30.8873L31.2243 33.3901C29.9017 34.3892 28.2737 35.4581 26.2545 35.7802C26.0508 35.8127 25.8386 35.8424 25.6184 35.8686C25.5133 35.8876 25.404 35.9001 25.2911 35.9044C24.2602 36.0068 23.0663 36.0306 21.7492 35.9062C20.9931 35.8348 20.4381 35.1641 20.5095 34.4081C20.5809 33.652 21.2517 33.097 22.0077 33.1684C23.158 33.277 24.19 33.253 25.0656 33.1631C25.0834 33.1613 25.1011 33.1595 25.1187 33.1576C25.1553 33.1363 25.2111 33.0976 25.2844 33.0337C25.8701 32.5225 25.9224 31.6664 25.3922 31.0709C25.2578 30.9199 25.0923 30.7844 24.8908 30.6642C22.7254 29.3726 19.8333 29.1568 16.7771 29.7489C13.7383 30.3376 10.7192 31.6939 8.46226 33.2944C7.84282 33.7337 6.98456 33.5877 6.54527 32.9682C6.10598 32.3488 6.25202 31.4905 6.87146 31.0512C9.43512 29.2332 12.816 27.7152 16.254 27.0491Z"
                      fill="white"
                    />
                  </svg>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.8 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.4,
                    delay: 0.2,
                  }}
                  className="right">
                  <p className="title">Local Health</p>
                  <p className="desc">Local health partner in Mississauga</p>
                </motion.div>
              </div>
            </div>
          </div>
        )}
      </InView>
    </div>
  );
};

export default Home;
